import { DEFAULT_TIMEZONE } from '@nx-ng/constants';
import { ICustomerDetailsPage, IFormValidationRules } from '@nx-ng/types';
import {
  getYesterdayUTCDate,
  MOBILE_REGEX,
  NAME_REGEX,
  POSTCODE_REGEX,
} from '@nx-ng/util';
import { utcToZonedTime } from 'date-fns-tz';
import { ValidationService } from './validation.service';

export class CustomerValidationService extends ValidationService<ICustomerDetailsPage> {
  constructor() {
    super();
  }

  additionalValidation(obj?: ICustomerDetailsPage) {
    return true;
  }

  rulesFromDefinition(
    obj?: ICustomerDetailsPage
  ): IFormValidationRules<ICustomerDetailsPage> {
    return {
      customerDetails: {
        firstName: {
          required: true,
          pattern: NAME_REGEX,
        },
        lastName: {
          required: true,
          pattern: NAME_REGEX,
        },
        telephoneNumber: {
          required: true,
          pattern: MOBILE_REGEX,
        },
        dateOfBirth: {
          required: true,
          maxDate: utcToZonedTime(getYesterdayUTCDate(), DEFAULT_TIMEZONE),
        },
        address: {
          address1: {
            required: true,
          },
          town: {
            required: true,
          },
          postCode: {
            required: true,
            pattern: new RegExp(POSTCODE_REGEX),
          },
        },
      },
      preferences: {
        keepInTouch: {
          required: true,
        },
      },
    };
  }
}
